import React from 'react';
import { useNavigate } from 'react-router-dom';
import OKSvg from "../../img/ok-svgrepo-com.svg";
import { addDevidersToString } from "./helper-functions";
import '../../css/card-creator.css';

const CardViewerTabs = ({
                              store, sortedCards, setQrData, setQrName, setActiveModalQr, startCardTest,
                              processing, setCardToDelete, setCardToUnbind, setActiveModalConfirm, setModalMessage,
                              activateCardWithoutTest, changeCardStatus
                          }) => {
    const navigate = useNavigate();

    const getColor = (percent) => {
        if (percent < 20) return '#F28B82';
        if (percent < 50) return '#FDD663';
        return '#81C995';
    };

    const isCardActive = (card) => {
        return card.active && !card.stopByFails && !card.stopByAdmin &&
            (card.device?.online || card.webHook) &&
            card.reminderOfLimit >= card.min;
    };

    return (
        <div className="mobile-card-list">
            {sortedCards.map((card, index) => {
                const percent = parseFloat(((card.reminderOfLimit / card.dayLimit) * 100).toFixed(1));
                const active = isCardActive(card);

                return (
                    <div key={card._id} className={`mobile-card-card ${active ? 'active-card' : 'inactive-card'}`}>
                        {/* Заголовок карточки */}
                        <div className="card-header">
                            <strong className="cardholder-name">{card.cardholder}</strong>

                        </div>

                        {store.user.roles.includes("support")
                            ?
                            <div className="card-header">
                                <strong className="cardholder-name">Трейдер: {card.user?.login}</strong>
                            </div>
                            :
                            null
                        }

                        {/* Основная информация */}
                        <div className="card-section">
                            <div>
                                <strong>Номер:</strong>
                                <span>{card.number ? "*" + card.number?.slice(-4) : "нет"}</span>
                            </div>
                            <div>
                                <strong>Трафик:</strong>
                                <span>{card.trafficType}</span>
                            </div>
                            <div>
                                <strong>Банк:</strong>
                                <strong className="bank-name">{card.bank}</strong>
                            </div>
                        </div>

                        {/* Статус и устройство */}
                        <div className="card-section">
                            <div>
                                <strong>Статус:</strong>
                                <span>
                                  {card.device?.online || card.isOnline
                                      ? <span className="green-bold">OnLine</span>
                                      : card.device && !card.isOnline && !card.webHook
                                          ? <span className="red-bold">OffLine</span>
                                          : card.webHook
                                              ? <span className="green-bold">WebHook</span>
                                              : <span className="red-bold">Не привязано</span>
                                  }
                                </span>
                            </div>
                            <div>
                                <strong>Активность:</strong>
                                <span className="align-right">
    {store.user.roles.includes("trader")
        ? renderTraderStatus(card, index)
        : renderSupportStatus(card, index, activateCardWithoutTest)}
  </span>
                            </div>

                        </div>


                        <div className="card-section">
                            {card.stopByFails ? (
                                card.test ? (
                                    card.test.numberAmount > 1 ? (
                                        <div className="card-info-single">
                                            Ждём перевод {card.test.numberAmount} ₽ по номеру карты
                                        </div>
                                    ) : card.test.sbpAmount ? (
                                        <div className="card-info-single">
                                            {card.test.numberAmount === 1 && (
                                                <div style={{
                                                    marginBottom: '5px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '5px'
                                                }}>
                                                    <span>По номеру ОК</span>
                                                    <img height="15px" src={OKSvg} alt="OK"/>
                                                </div>
                                            )}
                                            <div>
                                                Ждём перевод {card.test.sbpAmount} ₽{" "}
                                                {card.trafficType === "nspk"
                                                    ? "по QR-коду"
                                                    : card.trafficType === "applink_vtb"
                                                        ? ""
                                                        : "по СБП"}
                                            </div>
                                        </div>
                                    ) : null
                                ) : store.user.roles.includes("trader") ? (
                                    card.device || card.webHook ? (
                                        <button
                                            className="gradient-green-button mobile-card-btn"
                                            onClick={
                                                card.dynamicType
                                                    ?
                                                    () => {
                                                        store.setCardToEditId(card._id)
                                                        navigate('/create_card')

                                                    }
                                                    :
                                                    () => startCardTest(card._id)
                                            }
                                        >
                                            Тестировать
                                        </button>
                                    ) : (
                                        <div className="card-info-single red-bold">⚠️ Сначала привяжите устройство</div>
                                    )
                                ) : card.test ? (
                                    <div className="card-info-single">⚠️ На тесте</div>
                                ) : (
                                    <div className="card-info-single">⚠️ Ожидает тестирования</div>
                                )
                            ) : (
                                <>
                                    <div className="limit-bar">
                                        <div
                                            className="limit-fill"
                                            style={{
                                                width: `${percent}%`,
                                                backgroundColor: getColor(percent),
                                            }}
                                        ></div>
                                        <div className="limit-text centered">
                                            {addDevidersToString(card.reminderOfLimit?.toFixed(2))}
                                        </div>
                                    </div>
                                    <div className="card-info-single">
                                        В день: {card.todaysOrdersCount}/
                                        {!card.maxDailyOrders || card.maxDailyOrders === 0 ? "∞" : card.maxDailyOrders}
                                    </div>
                                    <div className="card-info-single">
                                        Интервал: {card.intervalBetweenTransactions || "нет"} м.
                                    </div>
                                    <div className="card-info-single">
                                        Одновременно: {card.limitOfOpened || "∞"}
                                    </div>
                                    <div className="card-info-single">
                                        Чеки от {card.min} до {card.max} ₽
                                    </div>
                                </>
                            )}
                        </div>


                        {/* Кнопки управления */}
                        {/*{!store.user.agent*/}
                        {/*    ?*/}
                            <div className="card-actions">
                                <button
                                    className="gradient-orange-button mobile-card-btn"
                                    onClick={() => {
                                        store.setCardToEditId(card._id);
                                        navigate('/create_card');
                                    }}
                                >
                                    Изменить
                                </button>

                                {store.user.roles.includes("support") ? (
                                    !card.stopByAdmin ? (
                                        <button
                                            className="gradient-red-button mobile-card-btn"
                                            onClick={() => changeCardStatus(card._id, index)}
                                        >
                                            Отключить
                                            {processing.status && processing.index === index && (
                                                <img src={require('../../img/loading.gif')} height="15px"
                                                     className="margin-left-20"/>
                                            )}
                                        </button>
                                    ) : (
                                        <button
                                            className="gradient-green-button mobile-card-btn"
                                            onClick={() => changeCardStatus(card._id, index)}
                                        >
                                            Включить
                                            {processing.status && processing.index === index && (
                                                <img src={require('../../img/loading.gif')} height="15px"
                                                     className="margin-left-20"/>
                                            )}
                                        </button>
                                    )
                                ) : card.active ? (
                                    <button
                                        className="gradient-red-button mobile-card-btn"
                                        onClick={() => changeCardStatus(card._id, index)}
                                    >
                                        Отключить
                                        {processing.status && processing.index === index && (
                                            <img src={require('../../img/loading.gif')} height="15px"
                                                 className="margin-left-20"/>
                                        )}
                                    </button>
                                ) : card.activeGroup ? (
                                        <button
                                            className="gradient-green-button mobile-card-btn"
                                            onClick={() => changeCardStatus(card._id, index)}
                                        >
                                            Включить
                                            {processing.status && processing.index === index && (
                                                <img src={require('../../img/loading.gif')} height="15px"
                                                     className="margin-left-20"/>
                                            )}
                                        </button>
                                    ) :
                                    card.group
                                        ?
                                        null
                                        :
                                        <button
                                            className="gradient-green-button mobile-card-btn"
                                            onClick={() => changeCardStatus(card._id, index)}
                                        >
                                            Включить
                                            {processing.status && processing.index === index && (
                                                <img src={require('../../img/loading.gif')} height="15px"
                                                     className="margin-left-20"/>
                                            )}
                                        </button>
                                }

                                {/*{card.active ? (*/}
                                {/*    <button*/}
                                {/*        className="gradient-red-button mobile-card-btn"*/}
                                {/*        onClick={() => changeCardStatus(card._id, index)}*/}
                                {/*    >*/}
                                {/*        Отключить*/}
                                {/*        {processing.status && processing.index === index && (*/}
                                {/*            <img src={require('../../img/loading.gif')} height="15px"*/}
                                {/*                 className="margin-left-20"/>*/}
                                {/*        )}*/}
                                {/*    </button>*/}
                                {/*) : (*/}
                                {/*    <button*/}
                                {/*        className="gradient-green-button mobile-card-btn"*/}
                                {/*        onClick={() => changeCardStatus(card._id, index)}*/}
                                {/*    >*/}
                                {/*        Включить*/}
                                {/*        {processing.status && processing.index === index && (*/}
                                {/*            <img src={require('../../img/loading.gif')} height="15px"*/}
                                {/*                 className="margin-left-20"/>*/}
                                {/*        )}*/}
                                {/*    </button>*/}
                                {/*)}*/}

                                {card.device && store.user.roles.includes("trader") && (
                                    <button
                                        className="gradient-dark-button mobile-card-btn"
                                        onClick={() => {
                                            if (card.group) {
                                                setModalMessage(`Вы действительно хотите отвязать карту ${card.number}\n${card.cardholder} от устройства?\nКарта также будет исключена из группы`);
                                            } else {
                                                setModalMessage(`Вы действительно хотите отвязать карту ${card.number}\n${card.cardholder} от устройства?`);
                                            }
                                            setCardToDelete();
                                            setCardToUnbind(card._id);
                                            setActiveModalConfirm("progress");
                                            setTimeout(() => {
                                                setActiveModalConfirm("active");
                                            }, 100);
                                        }}
                                    >
                                        Отвязать
                                    </button>
                                )}

                                {store.user.roles.includes("trader") && (
                                    <button
                                        className="gradient-dark-button mobile-card-btn"
                                        onClick={() => {
                                            setModalMessage(`Вы действительно хотите удалить карту ${card.number}\n${card.cardholder}`);
                                            setCardToUnbind();
                                            setCardToDelete(card._id);
                                            setActiveModalConfirm("progress");
                                            setTimeout(() => {
                                                setActiveModalConfirm("active");
                                            }, 100);
                                        }}
                                    >
                                        Удалить
                                    </button>
                                )}
                                {store.user.roles.includes("trader") && card.token && (
                                    card.group ? (
                                        <div className="card-info-single red-bold">Карта привязана к группе {card.group.name ? `"${card.group.name}"` : "" }</div>
                                    ) : (
                                        <button
                                            className="gradient-orange-button mobile-card-btn"
                                            onClick={() => {

                                                console.log(card)

                                                setQrData(card.token.token);
                                                setQrName(`${card.cardholder}\n${card.token.token}`);
                                                // setActiveModalQr("progress");
                                                // setTimeout(() => setActiveModalQr("active"), 100);
                                            }}
                                        >
                                            Токен
                                        </button>
                                    )
                                )}

                            </div>
                        {/*    :*/}
                        {/*    null*/}
                        {/*}*/}
                    </div>
                );
            })}
        </div>
    );
};

// Вспомогательные функции для рендеринга статусов
// function renderTraderStatus(card, index) {
//     if (card.stopByFails) {
//         return card.test ? "⚠️ На тесте" : "⚠️ Остановлена системой";
//     }
//     if (card.stopByAdmin) return "⚠️ Остановлена админом";
//     if (card.active) {
//         if (card.device?.online) {
//             return card.reminderOfLimit < card.min
//                 ? "⚠️ Не работает"
//                 : <span className="green-bold">В работе</span>;
//         }
//         return card.webHook
//             ? <span className="green-bold">В работе</span>
//             : <span className="red-bold">Ожидание соединения</span>;
//     }
//     return !card.activeGroup
//         ? <span className="red-bold">Остановлена группа</span>
//         : <span className="red-bold">Остановлена</span>;
// }

function renderTraderStatus(card, index) {
    if (card.stopByFails) {
        return card.test
            ? "⚠️ На тесте"
            : "⚠️ Остановлена системой";
    }

    if (card.stopByAdmin) {
        return "⚠️ Остановлена админом";
    }

    if (card.active) {
        if (card.device?.online) {
            if (card.reminderOfLimit < card.min) {
                return (
                    <span
                        className="red-bold"
                        title={"Эта карта больше не получит заявок, так как её минимальный разрешённый платёж превышает суточный остаток"}>
                        ⚠️ - не работает
                    </span>
                );
            }

            if (card.maxDailyOrders > 0 && card.todaysOrdersCount >= card.maxDailyOrders) {
                return (
                    <span
                        className="red-bold"
                        title={"Эта карта больше не получит заявок, так как достигнут её суточный лимит заявок"}>
                        ⚠️ - не работает
                    </span>
                );
            }

            return <span className="green-bold">В работе</span>;
        }

        return card.webHook
            ? <span className="green-bold">В работе</span>
            : <span className="red-bold">Ожидание соединения</span>;
    }

    return !card.activeGroup
        ? <span className="red-bold">Остановлена группа</span>
        : <span className="red-bold">Остановлена</span>;
}


// function renderSupportStatus(card, index, activateCardWithoutTest) {
//     if (card.active && !card.stopByFails) {
//         if (card.stopByAdmin) return "⚠️ Остановлена админом";
//         if (card.device?.online) {
//             return card.user?.active
//                 ? <span className="green-bold">В работе</span>
//                 : <span className="red-bold">Трейдер отключён</span>;
//         }
//         return card.webHook
//             ? card.user?.active
//                 ? <span className="green-bold">В работе</span>
//                 : <span className="red-bold">Трейдер отключён</span>
//             : <span className="red-bold">Ожидание соединения</span>;
//     }
//     if (card.stopByFails) {
//         return card.test
//             ? <div>⚠️ На тесте
//                 <button
//                     onClick={() => activateCardWithoutTest(card._id, index)}
//                     className={"gradient-green-button"}>Вкл.
//                 </button>
//             </div>
//             : <div>⚠️ Остановлена системой <button
//                 onClick={() => activateCardWithoutTest(card._id, index)}
//                 className={"gradient-green-button"}>Вкл.</button></div>;
//     }
//     return "⚠️ Остановлена трейдером";
// }

function renderSupportStatus(card, index, activateCardWithoutTest) {
    if (card.active && !card.stopByFails) {
        if (card.stopByAdmin) {
            return "⚠️ Остановлена админом";
        }

        if (card.device?.online) {
            if (!card.user?.active) {
                return <div className="red-bold">Трейдер отключён</div>;
            }

            if (card.reminderOfLimit < card.min) {
                return (
                    <span
                        className="red-bold"
                        title={"Эта карта больше не получит заявок, так как её минимальный разрешённый платёж превышает суточный остаток"}>
                        ⚠️ - не работает
                    </span>
                );
            }

            if (card.maxDailyOrders > 0 && card.todaysOrdersCount >= card.maxDailyOrders) {
                return (
                    <span
                        className="red-bold"
                        title={"Эта карта больше не получит заявок, так как достигнут её суточный лимит заявок"}>
                        ⚠️ - не работает
                    </span>
                );
            }

            return <div className="green-bold">В работе</div>;
        }

        if (card.webHook) {
            return card.user?.active
                ? <div className="green-bold">В работе</div>
                : <div className="red-bold">Трейдер отключён</div>;
        }

        return <div className="red-bold">Ожидание соединения</div>;
    }

    if (card.stopByFails) {
        return card.test
            ? (
                <div>
                    ⚠️ На тесте
                    <button
                        onClick={() => activateCardWithoutTest(card._id, index)}
                        className="gradient-green-button"
                    >
                        Вкл.
                    </button>
                </div>
            )
            : (
                <div>
                    ⚠️ Остановлена системой
                    <button
                        onClick={() => activateCardWithoutTest(card._id, index)}
                        className="gradient-green-button"
                    >
                        Вкл.
                    </button>
                </div>
            );
    }

    return "⚠️ Остановлена трейдером";
}


export default CardViewerTabs;